import { UserRole } from '../enums/UserRole'
import { ProjectMembershipRole } from '../enums/ProjectMembershipRole'
import { Company, Project, ProjectMembership, User } from '../types'
import { AuthUser } from '../types/auth'
import { RequestAccessProject } from '../types/RequestAccessProject'

export function userIsSuperadmin(user: User | AuthUser): boolean {
  return user?.role == UserRole.SUPERADMIN
}

export function userIsAdmin(user: User | AuthUser): boolean {
  return user?.role == UserRole.ADMIN
}

export function userIsUser(user: User): boolean {
  return user?.role == UserRole.USER
}

export function userIsManufacturer(user: User): boolean {
  return user?.role == UserRole.MANUFACTURER
}

export function userIsInstaller(user: User): boolean {
  return user?.role == UserRole.INSTALLER
}

export function userIsGuest(user: User): boolean {
  return user?.role == UserRole.GUEST
}

export function userBelongsToCompany(user: User | AuthUser, company: Company): boolean {
  return user?.company?.id === company.id
}

export function userIsOwnerOfProject(user: User | AuthUser, project: Project): boolean {
  return (
    user?.projects?.some((membership: ProjectMembership) => {
      return membership.projectId === project.id && membership.role === ProjectMembershipRole.OWNER
    }) ?? false
  )
}

export function userIsAdminOfProject(user: User | AuthUser, project: Project): boolean {
  return (
    user?.projects?.some((membership: ProjectMembership) => {
      return membership.projectId === project.id && membership.role === ProjectMembershipRole.ADMIN
    }) ?? false
  )
}

export function userIsUserOfProject(user: User | AuthUser, project: Project): boolean {
  return (
    user?.projects?.some((membership: ProjectMembership) => {
      return membership.projectId === project.id && membership.role === ProjectMembershipRole.USER
    }) ?? false
  )
}

export function userIsMemberOfProject(
  user: User | AuthUser,
  project: Project | RequestAccessProject
): boolean {
  return (
    user?.projects?.some((membership: ProjectMembership) => {
      return membership.projectId === project.id
    }) ?? false
  )
}
